<template>
    <div class="d-flex flex-column justify-space-between text-center pa-4" style="height: 100%">
        <app-logo style="height: 4rem" />
        <div class="pa-4" style="max-width: 40rem; align-self: center">
            <h3 class="mb-2">{{ title }}</h3>
            <p class="mb-4">{{ message }}</p>
            <app-button v-if="!hideDashboardButton" class="mb-0" @click="onBack">
                {{ $t('back_to') }} {{ $t('dashboard') }}
            </app-button>
        </div>
        <small class="text-right">
            Stuck on this page? Please contact our team on
            <a href="mailto:clientservices@growthinvest.com">clientservices@growthinvest.com</a>
        </small>
    </div>
</template>

<script>
import i18n from '@/lib/i18n';

export default {
    name: 'Page',
    components: {
        AppLogo: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppLogo'
            )
    },
    props: {
        title: {
            type: String,
            default: i18n.t('page_not_found')
        },
        message: {
            type: String,
            default: i18n.t('weve_encountered_a_problem_displaying_the_page_you_requested')
        },
        hideDashboardButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onBack() {
            location.href = '/';
        }
    }
};
</script>
